import React from "react";

export default function About() {
  return (
    <div className="py-20 md:py-28 px-6 md:px-10 max-w-6xl mx-auto" data-testid="about-page">
      <div className="overline mb-4">The Founder</div>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight">The Lion Chief</h1>
      <p className="mt-4 text-[#D4AF37] font-serif text-xl italic" data-testid="founder-byline">
        Founder of Lyon's Den Protection
      </p>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mt-14">
        <div className="md:col-span-5">
          <div
            className="aspect-[4/5] bg-cover bg-center border border-white/10"
            style={{ backgroundImage: "url('/jarvis-founder.jpeg')" }}
            data-testid="founder-portrait"
          />
          <div className="mt-6 overline text-[#D4AF37]">Southern Louisiana · Founder of Lyon's Den Protection</div>
        </div>

        <div className="md:col-span-7 space-y-6 text-white/75 leading-relaxed text-lg">
          <p>
            The Lion Chief was born and raised across rural Southern Louisiana — a place where
            spirituality is woven into the land, the food, and the people. His spiritual education has
            spanned decades and crossed many traditions: Catholicism, Christianity, Apostolic teachings,
            Islam, and various ancestral and folk spiritual systems.
          </p>
          <p>
            That breadth of study is the foundation of Lyon's Den Protection: a brand that does not borrow
            stereotypes or trade in fear. The Lion Chief works from a place of respect, lineage, and
            lived experience — offering guidance that is grounded, honest, and clear.
          </p>
          <p>
            As a professional tarot reader and spiritual advisor, he has helped clients across the country
            navigate grief, transition, relationships, career, and protection. He believes spiritual work
            is most powerful when paired with clarity, education, and practical action — never fear.
          </p>
          <p>
            Lyon's Den Protection exists to make trusted spiritual guidance, protection services, and
            handcrafted spiritual products accessible to everyone — from your first reading to your home
            cleansing, from a single candle to long-term spiritual mentorship.
          </p>

          <div className="grid grid-cols-2 gap-6 pt-6">
            <div>
              <div className="overline mb-1 text-[#D4AF37]">Roots</div>
              <div className="font-serif text-2xl">Southern Louisiana</div>
            </div>
            <div>
              <div className="overline mb-1 text-[#D4AF37]">Experience</div>
              <div className="font-serif text-2xl">Decades of Study</div>
            </div>
            <div>
              <div className="overline mb-1 text-[#D4AF37]">Approach</div>
              <div className="font-serif text-2xl">Education First</div>
            </div>
            <div>
              <div className="overline mb-1 text-[#D4AF37]">Philosophy</div>
              <div className="font-serif text-2xl">Empowerment, Never Fear</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
